import { Button } from "antd";
import React from "react";
import { Link } from "react-router-dom";
function ButtonWithIcon({
  text,
  onClick,
  icon,
  className,
  disabled,
  type,
  style,
  link,
  linkState,
}) {
  return (
    <>
      {link ? (
        <Link to={link} state={linkState}>
          <Button
            style={style}
            onClick={onClick}
            className={className}
            type={type}
            ghost
            disabled={disabled}
          >
            {" "}
            <img src={icon}></img>
            {text}
          </Button>
        </Link>
      ) : (
        <Button
          style={style}
          onClick={onClick}
          className={className}
          type={type}
          ghost
          disabled={disabled}
        >
          {icon && <img src={icon}></img>}
          <span className="-ml-[5px]">{text}</span>
        </Button>
      )}
    </>
  );
}

export default ButtonWithIcon;
